/**
 * usePlanningRunProgress (ENG-369)
 *
 * Live progress for an epic request's planning run. A thin wrapper around
 * useRunProgress("planning", id): it adds no polling of its own. SSE pushes
 * snapshots into the cache, and useRunProgress handles the fallback poll and
 * stops once the run is terminal.
 */

import { useRunProgress, type UseRunProgressResult } from "./useRunProgress";

export function usePlanningRunProgress(
  epicRequestId: string | null | undefined,
): UseRunProgressResult {
  return useRunProgress("planning", epicRequestId);
}
